import { createContext, useContext } from 'react';

export const TrackContext = createContext<{
  refresh: () => void;
}>({
  refresh: () => { },
})

export const useTrack = () => useContext(TrackContext);

